// constant for Seller::MarketProduct

export const LIVE_STATUS = {
  PENDING  : 'pending',
  LIVE     : 'live',
  DISABLED : 'disabled'
}

export const PROCESS_STATUS = {
  INCOMPLETE     : 'incomplete',
  PENDING        : 'pending',
  ON_REVIEW      : 'on_review',
  REVIEWED       : 'reviewed',
  PHOTO_EDITED   : 'photo_edited',
  PHOTO_UPLOADED : 'photo_uploaded',
  COMPLETED      : 'completed',
  REJECTED       : 'rejected'
}

export const CURATION_NOTE_STATUS = {
  NOT_RESPONDED    : 'not_responded',
  OPS_RESPONDED    : 'ops_responded',
  SELLER_RESPONDED : 'seller_responded'
}

export const CURATION_STATUS = {
  PENDING  : 'pending',
  ACCEPTED : 'accepted',
  REJECTED : 'rejected'
}

export const REJECT_REASON = {
  CANNOT_VERIFY_AUTHENTICITY : 'cannot_verify_authenticity',
  WORN_OUT                   : 'worn_out',
  NO_BRAND                   : 'no_brand',
  OUT_OF_CATEGORY            : 'out_of_category',
  OUT_OF_BRAND               : 'out_of_brand',
  REQUESTED_TO_RETURN        : 'requested_to_return',
  STAIN                      : 'stain',
  TORN                       : 'torn',
  EXPIRED                    : 'expired',
  REPETITIVE                 : 'repetitive',
  BASIC_WEAR                 : 'basic_wear',
  ALTERED                    : 'altered',
  USED_SPORTWEAR             : 'used_sportwear',
  NOT_WOMEN_WEAR             : 'not_women_wear',
  OUT_OF_PRICE_RANGE         : 'out_of_price_range',
  SAMPLE_ITEM                : 'sample_item',
  BUTTON_MISSING             : 'button_missing',
  SKIN_PEELING_OFF           : 'skin_peeling_off',
  ORNAMENT_IS_MISSING        : 'ornament_is_missing',
  AUTHENTICITY               : 'authenticity',
  BROKEN                     : 'broken',
  SCRATCH                    : 'scratch'
}

export const ACCEPTED_DATE = {
  ASC: {
    label : 'Oldest',
    value : 'asc'
  },
  DESC: {
    label : 'Newest',
    value : 'desc'
  }
}

export const PRODUCTABLE_TYPE = {
  FAST_SELL   : 'FastSell::Product',
  CONSIGNMENT : 'Seller::Product',
  MARKETPLACE : 'Seller::MarketProduct'
}

export const PRODUCTABLE_TYPE_LABEL = {
  [ PRODUCTABLE_TYPE.FAST_SELL ]   : 'Fast Sell',
  [ PRODUCTABLE_TYPE.CONSIGNMENT ] : 'Consignment',
  [ PRODUCTABLE_TYPE.MARKETPLACE ] : 'Marketplace'
}